module.exports = __webpack_public_path__ + "static/media/certifikata.5abc579c.png";